import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { copyEnquiryDetails, getEnquiryCopyTooltip, isEnquiryCopyable } from "./enquiry-copy";
import type { EnquiryRow } from "./enquiry-helpers";

type EnquiryCopyButtonProps = {
    row: EnquiryRow;
};

export const EnquiryCopyButton = ({ row }: EnquiryCopyButtonProps) => {
    const [copied, setCopied] = useState(false);

    if (!isEnquiryCopyable(row)) return null;

    const handleCopy = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        event.preventDefault();
        try {
            await copyEnquiryDetails(row);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1500);
        } catch {
            setCopied(false);
        }
    };

    return (
        <button
            type="button"
            data-stop-row-click
            onClick={handleCopy}
            className="rounded-md p-1.5 text-gray-400 transition hover:bg-violet-50 hover:text-violet-600"
            aria-label="Copy enquiry details"
            title={copied ? "Copied" : getEnquiryCopyTooltip(row)}
        >
            {copied ? <Check className="h-4 w-4 text-emerald-600" /> : <Copy className="h-4 w-4" />}
        </button>
    );
};
